//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdmSpisovyPlanStrediskoSpisovychUzlu.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Spisov� pl�ny pro st�ediska </Description>
//    <Author>      FFIALA													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-12                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.1
//AdtGeneratorConfig:[ T:(sslvspl) GID:(Web.Dia.Ts) V1:(ixs_tre,spis_pl,poznamka,aktivita,dat_zmena,zmenu_prov) V2:(ixs_tre,spis_pl,aktivita) K1:() K2:(f_sslvspl_ixs_tre,f_sslvspl_spis_pl) K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdmSpisovyPlanStrediskoSpisovychUzlu
    export function DetailAdmSpisovyPlanStrediskoSpisovychUzluDlg(
        parentContent: GContent,
        opt: {
            /** ixs_tre */
            ixs_tre: string | null,
            /** spis_pl */
            spis_pl: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdmSpisovyPlanStrediskoSpisovychUzlu', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdmSpisovyPlanStrediskoSpisovychUzlu#",
        ixs_tre: opt ? opt.ixs_tre : undefined,
        spis_pl: opt ? opt.spis_pl : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdmSpisovyPlanStrediskoSpisovychUzlu
    export function SeznamAdmSpisovyPlanStrediskoSpisovychUzluDlg(
        parentContent: GContent,
        opt: {
            /** ixs_tre */
            ixs_tre: string | null,
            /** spis_pl */
            spis_pl: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdmSpisovyPlanStrediskoSpisovychUzlu', { }]

    const options = {
        ID: "AdmAdmSpisovyPlanStrediskoSpisovychUzlu#",
        ixs_tre: opt ? opt.ixs_tre : undefined,
        spis_pl: opt ? opt.spis_pl : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
